import React from 'react';
import { map } from 'lodash';
import AbsoluteValue from '../../AbsoluteValue';
import PercentageValue from '../../PercentageValue';
import { percentageValue, splitByThousands } from '../../../../helpers/NumberFormatter';
import { spaceFooter } from '../../Datagrid/Footers';
import CopyToClipboard from '../../CopyToClipboard';
import { Link } from 'react-router-dom';
import ReadonlyLink from '../../../pages/home/ReadonlyLink';
import Tooltip from '../../Tooltip';

export const preAddSettings = {
	settingsForTable
};

function logoLink(item, entity) {
	return <a href={`/${entity}/${item.id}`}>
		<div
				className="logo"
				style={{ backgroundImage: `url(${item.image})` }}
		/>
	</a>;
}


function settingsForTable(mode, spotifyPreAddsAvailability = {
    isAvailable: true,
    isPartialAvailability: false,
  }) {

	const {
		isAvailable,
		isPartialAvailability,
	} = spotifyPreAddsAvailability;

	let columns = [
			{
				id: "logo",
				className: "logo-sell",
				headerClassName: "logo-sell no-sort",
				Header: "",
				accessor: "image",
				width: 60,
				sortable: false,
				Cell: (props) => {
						const onClickCall = (e) => {
								return onTitleClick(props.original);
						};
						return (
								<div className="logo-container">
										{logoLink(props.original, mode)}
								</div>
						);
				},
				Footer: spaceFooter
			},
	   {
				id: 'product',
				Header: 'Product',
				accessor: 'name',
				className: "imprint-name",
				headerClassName: "imprint-name no-sort",
				Header: "Product",
				accessor: "product_title",
				sortable: false,
				width: 260,
				Cell: (props) => {
					const onClickCall = (e) => {
							return onTitleClick(props.original);
					};
				return <span><span><b>{props.original.id ? <Link to={`/products/${props.original.id}`}>{props.value}</Link> : props.value}</b></span>
					By: {props.original.artist_name}
					<br/>
					<span className="isrc-holder with-copy">
						{props.original.id ? <CopyToClipboard value={props.original.upc}>UPC: {props.original.upc}</CopyToClipboard> : <span>UPC: {props.original.upc}</span>}</span>
					</span>
				},
				Footer: spaceFooter
	   },
	   {
			 id: 'release_date',
			 Header: 'Release Date',
			 accessor: 'release_date',
			 Footer: spaceFooter
		 },

	   {
		   id: 'apple_pre_adds',
		   Header: 'Apple Pre Adds',
		   // width: 70,
		   accessor: 'apple_pre_adds',
			 Cell: props => props.value ? <span>{splitByThousands(props.value)}</span> : '0',
	   },
	   {
		   id: 'spotify_pre_saves',
		   Header: 'Spotify Pre Saves',
		   accessor: 'spotify_pre_saves',
			 className: `${isPartialAvailability ? ' cell-with-note' : ''}`,
			 Header: props => <div>
						<div className="top-table-header-inner">
								Spotify Pre Save
								{ isPartialAvailability && (
										<div className="table-header-tooltip">                     
												<Tooltip position="bottom" message={`Please note: Spotify Pre Save data available since March 9 2026 only`} tooltipClass="toolbar-title-tooltip"/>
										</div>
								)}
						</div>
				</div>,
				Cell: props => 
						isPartialAvailability ? (
						<span className="table-cell-with-note">
								<div className="table-header-tooltip">                     
										<Tooltip position="bottom" message={`Please note: Spotify Pre Save data available since March 9 2026 only`} tooltipClass="toolbar-title-tooltip" noIcon>
												<span>{props.value ? <span>{splitByThousands(props.value)}*</span> : '0*'}</span>
										</Tooltip>
								</div></span>) : (
						<span>{props.value ? <span>{splitByThousands(props.value)}</span> : '0'}</span>
				),
	   },
	   {
		  id: 'total_pre_adds_and_pre_saves',
		  Header: 'Total Pre-Add/Pre Save',
		  accessor: 'total_pre_adds_and_pre_saves',
			Cell: props => props.value ? <span>{splitByThousands(props.value)}</span> : '0',
	  },

	];
	return columns.map(column=>{
		//column.show = modes[mode].includes(column.id);
		return column;
	});
}